// extracted by mini-css-extract-plugin
export default {"dashboardContainer":"Dashboard_dashboardContainer__IyoMy","mainContent":"Dashboard_mainContent__jd7jJ","pageContent":"Dashboard_pageContent__aAKue"};